import React from "react";
import styled from "@emotion/styled";
import { Link } from "gatsby";

const DropdownSectionDiv = styled.div`
    text-align: center;
    border-top: 1px solid #dbdbdb;
    display: block;
    padding: 10px 1em;
    background: #fafafa;
`;

const DropdownLink = styled(Link)`
    border-top: 1px solid #dbdbdb;
    color: #4a4a4a;
    display: flex;
    font-family: effra_medium, sans-serif;
    font-size: 14px;
    font-weight: 400;
    top: 41px;
    width: 100%;

    :hover {
        background: #fafafa;
    }

    :last-of-type {
        border-radius: 0 0 8px 8px;
    }
`;

const DropDownLink = ({ link, resourcesLink }) => {
    // for section headings
    if (typeof link.url_slug === "undefined") {
        return <DropdownSectionDiv key={link.title}>{link.title} </DropdownSectionDiv>;
    }
    return (
        <DropdownLink key={link.title} to={`${resourcesLink}${link.url_slug}`}>
            {link.title}
        </DropdownLink>
    );
};

// const FilterDropdownWrapper = styled.div`
//     position: relative;
//     box-shadow: rgba(0, 0, 0, 0.1) 0 1px 5px 0;
//     transition: box-shadow 0.1s ease-in-out;
//     margin-right: 1em;
//     border-radius: 8px;

//     // width: 260px;

//     z-index: 5;
//     font-family: "effra_medium", sans-serif;
//     color: #4a4a4a;
//     background: white;
//     font-size: 14px;
//     // max-height: 41px;
//     &:hover {
//         box-shadow: rgba(0, 0, 0, 0.1) 0 4px 20px 0;
//     }
//
//     &:focus {
//         padding: calc(1em - 1px);
//         outline: none;
//         border: 1px solid #72c6ec;
//         box-shadow: 0 0 8px #72c6ec;
//     }
// `;

export default DropDownLink;
